export var actionTypes;
(function (actionTypes) {
    actionTypes["SEEKING_STARTED"] = "seekingStarted";
    actionTypes["SEEKING_ENDED"] = "seekingEnded";
    actionTypes["DRAG_SEEKING_STARTED"] = "dragSeekingStarted";
    actionTypes["DRAG_SEEKING_ENDED"] = "dragSeekingEnded";
    actionTypes["OPEN_MODAL"] = "openModal";
    actionTypes["CLOSE_MODAL"] = "closeModal";
    actionTypes["TOGGLE_MODAL"] = "toggleModal";
    actionTypes["RELATIVE_SEEK"] = "relativeSeek";
    actionTypes["RELATIVE_SEEK_COMPLETED"] = "relativeSeekCompleted";
    actionTypes["ABSOLUTE_SEEK"] = "absoluteSeek";
    actionTypes["VOLUME_OPEN"] = "volumeOpen";
    actionTypes["VOLUME_CLOSE"] = "volumeClose";
    actionTypes["SHOW_UI"] = "showUI";
    actionTypes["HIDE_UI"] = "hideUI";
    actionTypes["HIDE_UI_COMPLETED"] = "hideUICompleted";
    actionTypes["TV_SEEKING_ENABLED"] = "TVenableSeek";
    actionTypes["TV_SEEKING_DISABLED"] = "TVdisableSeek";
    actionTypes["BINGE_WATCHING_OVERLAY_SHOW"] = "bingeWatchingOverlayShow";
    actionTypes["BINGE_WATCHING_OVERLAY_HIDE"] = "bingeWatchingOverlayHide";
    actionTypes["BINGE_WATCHING_OVERLAY_SET_REMAINING_TIME"] = "bingeWatchingOverlaySetRemainingTime";
    actionTypes["SET_IS_ON_LIVE_EDGE"] = "setIsOnLiveEdge";
})(actionTypes || (actionTypes = {}));
export const seekingStarted = () => ({
    type: actionTypes.SEEKING_STARTED,
});
export const seekingEnded = () => ({
    type: actionTypes.SEEKING_ENDED,
});
export const dragSeekingStarted = () => ({
    type: actionTypes.DRAG_SEEKING_STARTED,
});
export const dragSeekingEnded = () => ({
    type: actionTypes.DRAG_SEEKING_ENDED,
});
export const volumeOpen = () => ({
    type: actionTypes.VOLUME_OPEN,
});
export const volumeClose = () => ({
    type: actionTypes.VOLUME_CLOSE,
});
export const openModal = (modal) => ({
    type: actionTypes.OPEN_MODAL,
    modal,
});
export const closeModal = (modal) => ({
    type: actionTypes.CLOSE_MODAL,
    modal,
});
export const toggleModal = (modal, setting = null) => {
    return {
        type: actionTypes.TOGGLE_MODAL,
        modal,
        setting,
    };
};
export const relativeSeek = (relativeSeekAmount) => ({
    type: actionTypes.RELATIVE_SEEK,
    relativeSeekAmount,
});
export const relativeSeekCompleted = () => ({
    type: actionTypes.RELATIVE_SEEK_COMPLETED,
});
export const absoluteSeek = (dvrPoint) => ({
    type: actionTypes.ABSOLUTE_SEEK,
    dvrPoint,
});
export const showUI = () => ({
    type: actionTypes.SHOW_UI,
});
export const hideUI = () => ({
    type: actionTypes.HIDE_UI,
});
export const hideUICompleted = () => ({
    type: actionTypes.HIDE_UI_COMPLETED,
});
export const enableSeekOnTV = () => ({
    type: actionTypes.TV_SEEKING_ENABLED,
});
export const disableSeekOnTV = () => ({
    type: actionTypes.TV_SEEKING_DISABLED,
});
export const bingeWatchingOverlayShow = (remainingTime) => ({
    type: actionTypes.BINGE_WATCHING_OVERLAY_SHOW,
    remainingTime,
});
export const bingeWatchingOverlayHide = (isFromUserAction) => ({
    type: actionTypes.BINGE_WATCHING_OVERLAY_HIDE,
    isFromUserAction,
});
export const bingeWatchingOverlaySetRemainingTime = (remainingTime) => ({
    type: actionTypes.BINGE_WATCHING_OVERLAY_SET_REMAINING_TIME,
    remainingTime,
});
export const setIsOnLiveEdge = (isOnLiveEdge) => ({
    type: actionTypes.SET_IS_ON_LIVE_EDGE,
    isOnLiveEdge,
});
//# sourceMappingURL=actions.js.map